module.exports = __webpack_public_path__ + "static/media/QRCodeLogo.svg";